"use client";

import { useEffect, useState } from "react";
import Link from "next/link";
import CircolariCards from "./circolari-cards";
import { Circolare, CircolariBaseProps } from "@/types/circolari";
import { fetchSessionUser } from "@/lib/authClient";
import { Button } from "@/components/ui/button";
import PageSection from "@/components/shared/page-section";

export default function CircolariSection({
  circolari,
  isAdmin = false,
}: CircolariBaseProps) {
  const [localCircolari, setLocalCircolari] = useState<Circolare[]>(circolari);
  const [ready, setReady] = useState(false);
  const [loggedIn, setLoggedIn] = useState(false);
  const [isUserAdmin, setIsUserAdmin] = useState(isAdmin);

  useEffect(() => {
    (async () => {
      try {
        const user = await fetchSessionUser();
        if (user) {
          setLoggedIn(true);
          // Se non viene passato isAdmin dal parent, deducilo dal ruolo utente
          if (!isAdmin) setIsUserAdmin(user.role === "admin");
        } else {
          setLoggedIn(false);
        }
      } catch {
        setLoggedIn(false);
      } finally {
        setReady(true);
      }
    })();
  }, [isAdmin]);

  if (!ready) return null;

  if (!loggedIn) {
    return (
      <PageSection wide>
        <div className="max-w-xl mx-auto bg-(--card) text-(--card-foreground) border border-black/5 rounded-xl p-6 text-center shadow-sm">
          <h2 className="text-2xl font-semibold mb-2">Area riservata</h2>
          <p className="text-(--muted-foreground) mb-4">
            Per visualizzare le circolari devi effettuare l’accesso.
          </p>
          <Button asChild className="cursor-pointer bg-(--btn-bg) text-(--btn-foreground) hover:bg-(--btn-hover)">
            <Link href="/area-riservata">Vai alla pagina di login</Link>
          </Button>
        </div>
      </PageSection>
    );
  }

  return (
    <PageSection wide>
      <CircolariCards
          circolari={localCircolari}
          isAdmin={!!isUserAdmin}
          onDelete={(id) =>
            setLocalCircolari((prev) => prev.filter((c) => c._id !== id))
          }
        />
    </PageSection>
  );
}